import styled from 'styled-components';

export const SEOAnchorStyled = styled.a`
  &:focus-visible div {
    outline: var(--spacing-space2) solid var(--color-functional-focus);
  }

  &:focus:not(:focus-visible) div {
    outline: none;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:active {
    color: -webkit-activelink;
  }

  &:active div {
    color: unset;
  }

  && {
    cursor: pointer;

    & {
      text-decoration: none;
    }

    &:last-child .fuse-checkbox {
      margin-bottom: initial;
    }

    &:last-child .facet-category {
      margin: 0;
    }
  }
`;
